<template>
  <div v-bind="getEditableAttributes(block)">
    <EventCard
      v-if="block.__component === 'hogc-one-event-page.card'"
      :title="block.title"
      :title-icon="block.titleIcon"
      :title-icon-key="block.titleIconKey"
      :title-icon-alt="block.titleIconAlt"
      :corner-badge="block.cornerBadge"
      :body-blocks="block.bodyBlocks"
    />
    <EventActionButtons
      v-else-if="block.__component === 'hogc-one-event-page.action-button' && canShowAction(block)"
      class="mx-5 mt-4"
      :actions="[block]"
      @action="emitAction"
    />
    <EventKeyVisual
      v-else-if="block.__component === 'hogc-one-event-page.key-visual'"
      :image="block.image"
    />
  </div>
</template>

<script>
import { mapState } from 'vuex';
import { getStoryblokEditableAttributes } from '@/utils/storyblok-editable';
import { eventBus } from '@/utils/eventBus';
import EventActionButtons from '@/components/EventPage/EventActionButtons.vue';
import EventCard from '@/components/EventPage/EventCard.vue';
import EventKeyVisual from '@/components/EventPage/EventKeyVisual.vue';

export default {
  name: 'EventPageBlockRenderer',
  components: {
    EventActionButtons,
    EventCard,
    EventKeyVisual,
  },
  props: {
    block: {
      type: Object,
      required: true,
    },
  },
  computed: {
    ...mapState('profile', ['isLeader']),
  },
  methods: {
    canShowAction(block) {
      if (block.__component !== 'hogc-one-event-page.action-button') return true;
      return !block.forLeaders || this.isLeader;
    },
    emitAction(action) {
      eventBus.emit('event-page-action', action);
    },
    getEditableAttributes(block) {
      return getStoryblokEditableAttributes(block);
    },
  },
};
</script>
